import { render, staticRenderFns } from "./id-card-section.vue?vue&type=template&id=08da4888&"
import script from "./id-card-section.vue?vue&type=script&lang=js&"
export * from "./id-card-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports